<template v-if="Object.keys(plan).length > 0">
	<template
		v-for="(headline, headlineIndex) in plan.headlines"
		:key="headlineIndex"
	>
		<div class="card default-collapse p-1" style="margin-bottom: 1.5rem">
			<a
				class="card-header collapsed p-0"
				:style="isView ? { 'pointer-events': 'none' } : ''"
			>
				<div
					@click="
						plan.headlines[headlineIndex].isExpanded =
							!plan.headlines[headlineIndex].isExpanded
					"
					class="card-title"
					style="border-bottom: 1px solid #d0d0d0"
				>
					<div style="display: flex; align-items: center;">
						<font-awesome-icon
							v-if="plan.headlines[headlineIndex].isExpanded"
							:icon="
								plan.headlines[headlineIndex].isExpanded
									? 'fa fa-arrow-up'
									: 'fa fa-arrow-down'
							"
							color="#3a73b8"
							width="1rem"
						></font-awesome-icon>
						<span class="moretitle">
							&nbsp; {{ headline.cat_name }}</span
						>
					</div>
				</div>
			</a>
			<Collapse
				:when="plan.headlines[headlineIndex].isExpanded"
				class="v-collapse"
				style="margin-inline: 1.75rem"
			>
				<template
					v-for="(question, questionIndex) in plan.headlines[
						headlineIndex
					].questions"
					:key="questionIndex"
				>
					<div
						v-if="question.cat_name"
						class="card-title"
						style="margin-block: 1rem"
					>
						{{ question.cat_name }}
					</div>
					<div
						class="question d-flex"
						style="
							margin-block: 1rem;
							justify-content: space-between;
						"
						:style="
							question?.question_type?.trim()?.toLowerCase() ===
							'tekstfelt'
								? {
										'row-gap': '1rem',
										'flex-direction': 'column',
									}
								: ''
						"
					>
						<div class="black d-flex col-4 p-0">
							<span v-if="isQuestionValid(question)">
								{{
									getQuestionIndex(
										headlineIndex,
										questionIndex,
										question,
									)
								}}. {{ question.headlinetext }}
							</span>
						</div>
						<Question
							:is-view="isView"
							v-if="question?.question_type"
							:question="question"
							:answer="
								answers.find(
									(answer) =>
										answer.templates_id ===
										question.templates_id,
								).answer
							"
							@update:answer="updateAnswer(question, $event)"
						/>
					</div>
				</template>
			</Collapse>
		</div>
	</template>
</template>
<script setup>
import { ref, computed, watch } from "vue";
import { Collapse } from "vue-collapsed";
import Question from "./planQuestion.vue";

const props = defineProps({
	plan: Object,
	journalAnswers: Array,
	isView: Boolean,
});
const plan = computed(() => {
	const plan = props.plan;
	if (plan && Object.keys(plan).length > 0) {
		plan.headlines.map((headline) => (headline.isExpanded = true));
	}
	return plan;
});
const journalAnswers = ref(props.journalAnswers);

const isQuestionValid = (question) => question && question.question_type;

const getQuestionIndex = (headlineIndex, questionIndex) => {
	let index = 1;

	for (let i = 0; i <= headlineIndex; i++) {
		const questions = plan.value.headlines[i].questions;

		for (let j = 0; j < questions.length; j++) {
			const currentQuestion = questions[j];

			if (isQuestionValid(currentQuestion)) {
				index++;
			}
			if (i === headlineIndex && j === questionIndex) {
				return index - 1;
			}
			if (!isQuestionValid(currentQuestion)) {
				index = 1;
			}
			if (i !== headlineIndex) {
				index = 1;
			}
		}
	}

	return index;
};

const answers = computed(() => {
	const answers = [];
	plan.value.headlines.forEach((headline) => {
		headline.questions.forEach((question) => {
			const journalAnswer = journalAnswers.value?.find(
				(answer) => answer.template_id === question.templates_id,
			);
			if (journalAnswer) {
				question.answer = journalAnswer.value;
				question.td_id = journalAnswer.td_id;
			}
			answers.push(question);
		});
	});
	return answers;
});

const updateAnswer = (question, value) => {
	answers.value.find((answer) => {
		if (answer.templates_id === question.templates_id) {
			answer.answer = value;
		}
	});
	emit("answers", answers.value);
};
const emit = defineEmits(["answers"]);
</script>
